// ── App-wide constants ─────────────────────────────────────────────────────────

export const MONTHS     = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const MONTH_FULL = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export const TASK_TYPES = ["prune","feed","mulch","divide","water","deadhead","plant/sow","note"];

const now = new Date();
export const CURRENT_MONTH = now.getMonth() + 1;
export const CURRENT_YEAR  = now.getFullYear();
